import { render, staticRenderFns } from "./HandoverRow.vue?vue&type=template&id=e556dd20"
import script from "./HandoverRow.vue?vue&type=script&lang=js"
export * from "./HandoverRow.vue?vue&type=script&lang=js"
import style0 from "./HandoverRow.vue?vue&type=style&index=0&id=e556dd20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports